import React, { useState } from "react";
import {
  MainWrap,
  MainHead,
  LogoImage,
  HeaderBtn,
  LogoImageDiv,
} from "../../styles/headerStyle";

import { Link, NavLink, } from "react-router-dom";
import { NavButton } from "../../styles/reusable";
import { useNavigate } from "react-router-dom";


interface Props {
  logo: string;
  hideContact: boolean;
  width?: string;
  top?: string;
  mobileWidth?: string;
}
const AppHeader = ({ logo, hideContact, width, top, mobileWidth }: Props) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpened] = useState<boolean>(false)

  return (

    <MainWrap>
      <div style={{ width: '100%' }}>
        <MainHead $isOpended={isOpen} >
          <div className="nav-container">
            <div className="nav-holder">
              <Link to="/">
                <LogoImageDiv>
                  <LogoImage
                    width={width}

                    src="favicon.ico"
                    alt="sixth"
                  />
                </LogoImageDiv>
              </Link>
              <HeaderBtn $isOpended={isOpen} onClick={() => {
                setIsOpened(!isOpen)
              }} >
                <div className="wrapper">
                  <div />
                  <div />
                </div>
              </HeaderBtn>

            </div>
            <div className="links-container">
              {
                data.map((item, index) => (
                  <ul className="row-item" key={"link-header" + index}>
                    <li className="row-item-header">
                      <h6> {item.header} </h6>


                    </li>
                    {
                      item.links.map((linkItem, linkIndex) => (
                        <li className="row-item" key={"link" + linkIndex}>
                          {
                            linkItem.link !== "" ? <NavButton padding="0" >

                              <NavLink to={linkItem.link} > {linkItem.name}</NavLink>
                            </NavButton> : <NavButton padding="0" onClick={linkItem.onclick}>

                              <p> {linkItem.name}</p>
                            </NavButton>
                          }


                        </li>

                      ))
                    }



                  </ul>
                ))
              }

            </div>



          </div>


          {true ? null : (
            <HeaderBtn
            // to='/contact
            >
              <NavButton onClick={() => navigate("/")}>
                <NavLink to="/">Home</NavLink>
              </NavButton>
              {
                //  <NavButton  onClick={() => navigate("/products")}>
                //  <Link to="/products">Products</Link>
                //</NavButton>
              }

              <NavButton onClick={() => navigate("/pricing")}>
                <Link to="/pricing">Pricing</Link>
              </NavButton>

              <NavButton onClick={() => navigate("/enterprise")}>
                <Link to="/enterprise">Enterprise</Link>
              </NavButton>




              { }
            </HeaderBtn>
          )}




        </MainHead>

      </div>




    </MainWrap>

  );
};

const data = [
  {
    header: "Explore ",
    links: [{
      name: "Enterprise",
      link: "/enterprise",
      onclick: () => { }
    }, {
      name: "Pricing",
      link: "/pricing",
      onclick: () => { }
    },
    {
      name: "Blog ",
      link: "",
      onclick: () => {
        window.location.href = "https://blog.trysixth.com/";
      }
    },]
  },
  {
    header: "Resource ",
    links: [{
      name: "Documentation",
      link: "",
      onclick: () => {
        window.location.href = "https://docs.trysixth.com";
      }
    }, {
      name: "Privacy Policy",
      link: "/privacy",
      onclick: () => { }
    },
    {
      name: "Terms of service",
      link: "/terms",
      onclick: () => { }
    },
    ]
  },
  {
    header: "Contact ",
    links: [{
      name: "Email us",
      link: "",
      onclick: () => {
    window.location.href = "mailto:ope@trysixth.com?subject=Contact%20Us&body=Hello%20Sixth%20Team,";
  }
    }, {
      name: "Book demo",
      link: "",
      onclick:() => {
          window.open("https://calendly.com/ope-trysixth/30min", "_blank");
        },
    },

    ]
  },


]
export default AppHeader;
